// @mui material components
import Divider from "@mui/material/Divider";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Data

// Images
import ProjectsTable from "../tables/previousProjectsTable";

const AllPreviousProjects = ({ onClick }) => {
  return (
    <MDBox>
      {/* from here */}
      <MDBox pt={2} px={2} lineHeight={1.25}>
        <MDTypography variant="h6" fontWeight="large">
          Your Previous Projects
        </MDTypography>
      </MDBox>
      <Divider
        sx={{ borderBottom: "2px solid rgba(0, 0, 0, 0.12)" }}
        variant="middle"
      />
      <MDBox>
        <ProjectsTable />
      </MDBox>

      {/* to here */}
    </MDBox>
  );
};

export default AllPreviousProjects;
